import { render, staticRenderFns } from "./usage.vue?vue&type=template&id=ddfab056&scoped=true"
import script from "./usage.vue?vue&type=script&lang=js"
export * from "./usage.vue?vue&type=script&lang=js"
import style0 from "./usage.vue?vue&type=style&index=0&id=ddfab056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfab056",
  null
  
)

export default component.exports